import { User } from 'models/User';
import { DealRoom } from 'models/DealRoom';
import { Listing, LISTING_STAGE } from 'models/Listing';
import { ObjectValues } from 'types';

export const LISTING_METRICS_PAYMENT_STATUS = {
  PAID: 'paid',
  INVOICE_GENERATED: 'invoice_generated',
  INVOICE_SKIPPED: 'invoice_skipped',
  SUPER_ADMIN_SKIPPED: 'super_admin_skipped',
  CLIENT_BYPASS: 'client_bypass',
  INVOICE: 'invoice',
  NOT_PAID: 'not_paid',
} as const;

export type ListingMetricsPaymentStatus = ObjectValues<
  typeof LISTING_METRICS_PAYMENT_STATUS
>;

export const BM_PAYMENT_RESPONSE_STATUS = {
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  PENDING: 'pending',
} as const;

export type BmPaymentResponse = ObjectValues<typeof BM_PAYMENT_RESPONSE_STATUS>;

export type DashboardMetric = {
  _id: string;

  title: string;
  titleSort: string;
  stage: MetricListingStage;
  paidPackage: MetricListingPaidPackage;
  expiresOn: Date;
  publishedOn: Date;
  lastEdited: Date | string;
  hasIM: boolean;
  hasNDA: boolean;
  numberOfEnquiries: number;
  numberOfAccepted: number;
  numberOfProspects: number;
  numberOfBidders: number;
  brokerName: string;
  brokerNameSort: string;
  brokerageFirm: string;
  brokerageFirmSort: string;

  paymentStatus: ListingMetricsPaymentStatus;
  bmPaymentResponse: BmPaymentResponse;
  reasonBmPaymentResponse?: string;

  //filter fields
  isResolveManagedListing: boolean;
  isPausedListing: boolean;
  isSoldListing: boolean;

  listing: Listing;
  dealRoom: DealRoom;
  user: User;

  //search field
  searchValue: string; //combination of listing title and broker name
};

export const METRIC_LISTING_STAGE = {
  PUBLIC: LISTING_STAGE.PUBLIC,
  PRIVATE: LISTING_STAGE.PRIVATE,
  PAUSED: LISTING_STAGE.PAUSED,
  ENDED: LISTING_STAGE.ENDED,
} as const;

type MetricListingStage = ObjectValues<typeof METRIC_LISTING_STAGE>;

const METRIC_LISTING_PAID_PACKAGE = {
  STANDARD: 'standard',
  PREMIUM: 'premium',
  PLATINUM: 'platinum',
  BASIC: 'basic',
  COMPREHENSIVE: 'comprehensive',
} as const;

export const METRICS_LISTING_PAID_PACKAGE_LABEL = {
  [METRIC_LISTING_PAID_PACKAGE.STANDARD]: 'bronze_title',
  [METRIC_LISTING_PAID_PACKAGE.PREMIUM]: 'silver_title',
  [METRIC_LISTING_PAID_PACKAGE.PLATINUM]: 'gold_title',
  [METRIC_LISTING_PAID_PACKAGE.BASIC]: 'basic_title',
  [METRIC_LISTING_PAID_PACKAGE.COMPREHENSIVE]: 'comprehensive_title',
} as const;

type MetricListingPaidPackage = ObjectValues<
  typeof METRIC_LISTING_PAID_PACKAGE
>;

export type PaymentInvoiceSkippedFormProps = {
  bmPaymentResponse: BmPaymentResponse;
  reasonBmPaymentResponse?: string;
};
